import { render, staticRenderFns } from "./SessionDetail.vue?vue&type=template&id=6408beaa&scoped=true&lang=pug"
import script from "./SessionDetail.vue?vue&type=script&lang=js"
export * from "./SessionDetail.vue?vue&type=script&lang=js"
import style0 from "./SessionDetail.vue?vue&type=style&index=0&id=6408beaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6408beaa",
  null
  
)

export default component.exports